import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { t } from 'i18next';

import { attributeStatusColorMap, attributeStatusLabelKey } from 'companySettings/constants';
import { AttributeStatus } from 'companySettings/enums';
import { IPartFinderProductType } from 'companySettings/types';
import { StatusCell } from 'core/elements';
import { AgGridFilterOption } from 'core/enums';

import { IdCell } from './cells';

const formatStatus = ({ value }: ValueFormatterParams) =>
  value ? t(attributeStatusLabelKey[value as AttributeStatus]) : '';

// Default widths that fit the content; the user can resize any column, and Save Layout keeps it.
export const getColumnDefs = (): ColDef<IPartFinderProductType>[] => [
  {
    colId: 'id',
    width: 90,
    headerName: t('headerId'),
    field: 'id',
    filter: 'agNumberColumnFilter',
    cellRenderer: IdCell,
  },
  {
    colId: 'name',
    width: 260,
    headerName: t('headerName'),
    field: 'name',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'attributesCount',
    width: 120,
    headerName: t('headerAttributes'),
    field: 'attributesCount',
    filter: 'agNumberColumnFilter',
    // A count is filtered as "at least".
    filterParams: { defaultOption: AgGridFilterOption.GREATER_THAN_OR_EQUAL },
  },
  {
    colId: 'familiesCount',
    width: 120,
    headerName: t('headerFamilies'),
    field: 'familiesCount',
    filter: 'agNumberColumnFilter',
    // A count is filtered as "at least".
    filterParams: { defaultOption: AgGridFilterOption.GREATER_THAN_OR_EQUAL },
  },
  {
    colId: 'status',
    width: 140,
    headerName: t('headerStatus'),
    field: 'status',
    filter: 'agSetColumnFilter',
    filterParams: { valueFormatter: formatStatus },
    // The label, not the stored value, in a download.
    valueFormatter: formatStatus,
    cellRenderer: StatusCell,
    cellRendererParams: {
      colorMap: attributeStatusColorMap,
      labelMap: Object.fromEntries(
        Object.entries(attributeStatusLabelKey).map(([status, labelKey]) => [status, t(labelKey)])
      ),
    },
  },
  {
    colId: 'versionNumber',
    width: 100,
    headerName: t('headerVersion'),
    field: 'versionNumber',
    valueFormatter: ({ value }: ValueFormatterParams) =>
      value ? t('labelVersionNumber', { number: value }) : '',
  },
];
